export function commentsSlider() {
    const $sliders = $(".comments-slider");
    const $breakPoint = 1199;
    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1.35
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            }
        ]
    }
    const settingsDeviceOnlyslider = {
        dots: true,
        arrows: false,
        infinite: false,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1.35
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 1199,
                settings: "unslick"
            }
        ]
    }


    function sliderInit() {
        $sliders.each(function () {
            const $slider = $(this);
            if($slider.hasClass('device-only-slider')){
                if(($(window).innerWidth() < $breakPoint) && !$slider.hasClass("slick-initialized")){
                    $slider.slick(settingsDeviceOnlyslider);
                }
            }
            if(!$slider.hasClass('device-only-slider')){
                $slider.not('.slick-initialized').slick(settings);
            }
        })
    }

    $(window).on("load resize", function () {
        sliderInit();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/commentsSlider.js